var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArb = function SvgArb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 44 44"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "#213147",
    rx: 22
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#213147",
    d: "M7.21 15.031v13.938a2.49 2.49 0 0 0 1.265 2.157l12.257 6.97a2.57 2.57 0 0 0 2.528 0l12.253-6.972a2.48 2.48 0 0 0 1.264-2.153V15.029a2.48 2.48 0 0 0-1.264-2.155L23.26 5.904a2.57 2.57 0 0 0-2.528 0L8.475 12.875a2.47 2.47 0 0 0-1.264 2.155Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#12AAFF",
    d: "m24.674 24.705-1.748 4.72a.6.6 0 0 0 0 .406l3.009 8.122 3.476-1.977-4.174-11.271a.3.3 0 0 0-.563 0m3.505-7.939a.3.3 0 0 0-.563 0l-1.748 4.721a.6.6 0 0 0 0 .405l4.926 13.298 3.479-1.977z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DCCED",
    d: "M21.996 6.425a.6.6 0 0 1 .249.065l13.264 7.542a.5.5 0 0 1 .249.423v15.081a.49.49 0 0 1-.249.423l-13.264 7.544a.5.5 0 0 1-.249.063.6.6 0 0 1-.247-.063L8.485 29.967a.5.5 0 0 1-.249-.425V14.46a.49.49 0 0 1 .249-.425l13.264-7.542a.5.5 0 0 1 .247-.067Zm0-2.202c-.47 0-.944.118-1.367.361l-13.26 7.54A2.69 2.69 0 0 0 6 14.459V29.54c0 .962.521 1.853 1.369 2.333l13.262 7.544a2.79 2.79 0 0 0 2.738 0l13.262-7.542A2.69 2.69 0 0 0 38 29.54V14.46a2.69 2.69 0 0 0-1.369-2.335l-13.266-7.54a2.77 2.77 0 0 0-1.369-.361Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#213147",
    d: "m13.227 35.209 1.218-3.291 2.458 2.01-2.298 2.067z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20.883 13.379H17.52a.59.59 0 0 0-.563.39L9.75 33.228l3.479 1.977 7.936-21.43a.296.296 0 0 0-.145-.363.3.3 0 0 0-.137-.034Zm5.884 0h-3.364a.59.59 0 0 0-.56.39L14.61 35.99l3.479 1.976 8.958-24.19a.298.298 0 0 0-.28-.397"
  })));
};
export default SvgArb;